import React, { useEffect, useState } from "react";
import "../styles/exploreTeam.css";
import Card from "./Card";
import firebase from "../firebase";
import { motion } from "framer-motion";

const ExploreTeam = ({ match }) => {
  // Member Logic
  // console.log(match.params.id);

  const [members, setMembers] = useState([]);
  const [lead, setLead] = useState({});
  const [loading, setLoading] = useState(false);
  const refMembers = firebase.firestore().collection("members");
  function getLead(teamID) {
    setLoading(!loading);
    refMembers
      .where("teamID", "==", teamID)
      .where("role", "==", "Lead")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setLead(items[0]);
      });
    setLoading(!loading);
  }
  function getMembers(teamID) {
    setLoading(!loading);
    refMembers
      .where("teamID", "==", teamID)
      .where("role", "!=", "Lead")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setMembers(items);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getLead(match.params.id);
    getMembers(match.params.id);
  }, []);
  // console.log(lead);
  // console.log(members);
  // console.log(members);
  // console.log(members);
  // const members = [1, 2, 3, 4, 5];
  let outsideArr = [];
  let insideArr = [];

  // const groupNumber = Math.ceil(members.length / 3);
  for (let j = 0; j < members.length; j += 3) {
    for (let i = j; i < j + 3; i++) {
      if (members[i]) {
        insideArr.push(members[i]);
      }
    }
    outsideArr.push(insideArr);
    insideArr = [];
  }

  // console.log(outsideArr);
  // console.log(insideArr);
  // Next page svg onclick handler
  const nextPage = () => {
    let pageHeight = window.innerHeight;
    window.scrollBy(0, pageHeight);
  };
  return (
    <div>
      <div
        className="
      first-page-wrapper
      flex
      flex-col
      items-center
      md:h-screen
      relative
      "
      >
        <div
          className="first-page
        flex
        flex-col-reverse
        
        w-full
        md:w-11/12
        md:flex-row
        h-screen
        items-center
        justify-center
        m-0
        "
        >
          <div
            className="
          left-content
          h-1/2
          w-full
          flex
          flex-col
          justify-center
          items-center
          text-3xl
          dark:text-white
          "
          >
            {lead.team && (
              <h1
                className="
              text-5xl
              md:text-6xl
              md:font-medium
              
            "
              >
                {lead.team.name}
              </h1>
            )}
            {lead.team && (
              <p
                className="
              text-2xl
              md:text-3xl
              text-gray-800
              mt-3
              dark:text-gray-400
            "
              >
                {lead.team.description}
              </p>
            )}
          </div>
          <div
            className="right-team-vector
            h-1/2
            md:h-full
            w-full
            flex
            items-center
            justify-center
          "
          >
            <div
              className="vector
                w-full
                h-3/4
                md:w-11/12
            "
            ></div>
          </div>
        </div>
        <motion.div
          className="next-page-button"
          onClick={nextPage}
          initial={{ y: -2 }}
          animate={{ y: 2 }}
          transition={{ yoyo: Infinity }}
        >
          <svg
            width="60"
            height="60"
            viewBox="0 0 98 97"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M73.3079 72.9236C66.861 79.3704 58.1172 82.9922 49 82.9922C39.8828 82.9922 31.139 79.3704 24.6921 72.9236C18.2453 66.4767 14.6235 57.7329 14.6235 48.6157C14.6235 39.4985 18.2453 30.7547 24.6921 24.3079C31.139 17.861 39.8828 14.2392 49 14.2392C58.1172 14.2392 66.861 17.861 73.3079 24.3079C79.7547 30.7547 83.3765 39.4985 83.3765 48.6157C83.3765 57.7329 79.7547 66.4767 73.3079 72.9236ZM35.3268 53.1734L47.4808 65.3274C47.8837 65.7303 48.4302 65.9567 49 65.9567C49.5698 65.9567 50.1163 65.7303 50.5192 65.3274L62.6732 53.1734C63.0761 52.7705 63.3025 52.224 63.3025 51.6542C63.3025 51.0844 63.0761 50.5379 62.6732 50.135C62.2702 49.732 61.7238 49.5057 61.1539 49.5057C60.5841 49.5057 60.0376 49.732 59.6347 50.135L51.1482 58.6214L51.1512 33.4233C51.1512 32.8528 50.9246 32.3056 50.5212 31.9021C50.1177 31.4987 49.5705 31.2721 49 31.2721C48.4295 31.2721 47.8823 31.4987 47.4788 31.9021C47.0754 32.3056 46.8488 32.8528 46.8488 33.4233L46.8518 58.6214L38.3653 50.135C37.9624 49.732 37.4159 49.5057 36.8461 49.5057C36.2762 49.5057 35.7298 49.732 35.3268 50.135C34.9239 50.5379 34.6975 51.0844 34.6975 51.6542C34.6975 52.224 34.9239 52.7705 35.3268 53.1734Z"
              fill="#06062D"
            />
          </svg>
        </motion.div>
      </div>

      <div
        className="team-lead
        h-screen
        flex
        flex-col
        justify-around
        md:justify-center
        items-center
        relative
      "
      >
        <h1
          className="headline
          mb-4
          md:mb-28
          text-5xl
          relative
          dark:text-white
        "
        >
          Team Lead
        </h1>
        {lead && (
          <div className="lead-card">
            <Card
              name={lead.name}
              image={lead.profileImage}
              skill={lead.description}
              position={lead.role}
              classStudying={lead.department}
              year={lead.year}
              linkedin={lead.linkedin ? lead.linkedin : ""}
              github={lead.github ? lead.github : ""}
              facebook={lead.facebook ? lead.facebook : ""}
              instagram={lead.instagram ? lead.instagram : ""}
            />
          </div>
        )}
      </div>

      <div
        className="team-members
        flex
        flex-col
        items-center
        justify-evenly
        relative
      "
      >
        <h1
          className="headline
          mt-20
          mb-1
          md:mb-12
          relative
          text-5xl
          dark:text-white
        "
        >
          The Team
        </h1>
        {lead && (
          <div>
            {outsideArr.map((element, index) => (
              <div
                key={index}
                className="member-cards
              flex-col
              md:flex
              md:flex-row
              items-center
              justify-between
              my-12
            "
              >
                {element.map((insideElement) =>
                  insideElement.role === "Lead" ? null : (
                    <div key={insideElement.id}>
                      <Card
                        name={insideElement.name}
                        image={insideElement.profileImage}
                        skill={insideElement.description}
                        position={insideElement.role}
                        classStudying={insideElement.department}
                        year={insideElement.year}
                        linkedin={insideElement.linkedin}
                        github={insideElement.github}
                        facebook={insideElement.facebook}
                        instagram={insideElement.instagram}
                      />
                    </div>
                  )
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExploreTeam;
